export var setScrollbar = function () {
    if (isBodyOverflowing()) {
        document.body.style.paddingRight = getScrollbarWidth() + 'px';
    }
};
export var resetScrollbar = function () {
    document.body.style.paddingRight = '0';
};
var getScrollbarWidth = function () {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'pcty-scrollbar-measure';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
};
var isBodyOverflowing = function () {
    var rect = document.body.getBoundingClientRect();
    return rect.left + rect.right < window.innerWidth;
};
